/*
  Elan By Kristen — measures the real header's live position on mobile so
  the menu drawer (assets/elan-overrides.css) can start exactly below it
  instead of covering it. Additive only: does not modify any native
  component's own script.

  Also continuously tracks the header's top position (--elan-header-top),
  not just at drawer-open time: this theme's scroll-lock sets
  overflow:hidden on an ancestor when the drawer opens, which breaks
  position:sticky entirely (a standard CSS behavior — sticky stops working
  if any ancestor between it and the scroll container has overflow other
  than visible), so the header falls back to its normal in-flow position,
  which is off-screen once the page has been scrolled. Tracking
  continuously (not just reactively when the drawer opens) avoids a race
  against the native toggle/scroll-lock timing — elan-overrides.css
  freezes the header at this last-known-good value via position:fixed
  while the drawer is open, which is immune to the same overflow bug.
*/
(function () {
  var header = document.querySelector('.header-section');
  if (!header) return;

  var ticking = false;

  function update() {
    ticking = false;
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--elan-header-top', Math.max(rect.top, 0) + 'px');
    document.documentElement.style.setProperty('--elan-header-bottom', Math.max(rect.bottom, 0) + 'px');
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
})();
